import R from 'ramda'

export default (directions) => {
	console.log(directions)
  const waypointToPolylines = (w) => R.pick(['lat', 'lng'], w)
  const segmentsToPolylines = (s) => R.chain(waypointToPolylines, s.waypoints)
  const directionToPolylines = (d) => R.chain(segmentsToPolylines, d.segments)
	/*const directionToPolylines = (d) => {
		var pols = [];
		var prevTT = ""; 
		var segmToDraw = [];
		for(var s in d.segments){

			var seg = d.segments[s];

			if(prevTT !== seg.type && s != 0){
				//segmToDraw.type = prevTT; 
				pols.push(segmToDraw);
				segmToDraw = []; 		
			}
			prevTT = seg.type; 
			for(var w in seg.waypoints){
				var wp = seg.waypoints[w]; 
				segmToDraw.push({lat:wp.lat, lng:wp.lng, color:'Orange'});
				//console.log([wp.lat, wp.lng]); 		
			}	
		}
		//segmToDraw.type = prevTT; 
		pols.push(segmToDraw);
		//console.log(pols); 
		return pols;
	}*/

  return R.map(directionToPolylines, directions)
}



/** WEBPACK FOOTER **
 ** ./app/utils/directionsToPolylines.js
 **/